import { Accordion } from '@material-ui/core'
import styled from 'styled-components/macro'

export const StyledAccordion = styled(Accordion)`
  border-radius: 15px !important;
`
